<template functional>
  <a
    :class="[
      data.class,
      data.staticClass
    ]"
    @click.prevent="parent.$router.go(-1)"
  >
    <v-icon type="angle-left" />
    {{ parent.$t('general.back') }}
  </a>
</template>
<script>
export default {
  name: 'GoBackButton'
}
</script>
